import { PlatformType as o } from "../../constants/platform.js";
import * as t from "yup";
const a = t.mixed().oneOf(Object.values(o)).default(o.Mac), e = t.object({
  circular: t.string().default(""),
  long: t.string().default(""),
  normal: t.string().default("")
}), c = t.object({
  icon: e,
  name: t.string().default("")
}), m = c.concat(
  t.object({
    type: a
  })
);
export {
  c as plaformShareSchema,
  m as platformSchema
};
//# sourceMappingURL=platform.js.map
